import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgendamentoService } from 'src/app/services/AgendamentoService/agendamento.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';
import { BRAND } from 'src/app/core/constants/brand';

@Component({
  selector: 'app-ticket-agendamento',
  templateUrl: './ticket-agendamento.component.html',
  styleUrls: ['./ticket-agendamento.component.scss']
})
export class TicketAgendamentoComponent implements OnInit {
  readonly brand = BRAND;
  idTicket: number = 0;
  isLoading: boolean = true;

  constructor(
    private agendamentoService: AgendamentoService,
    private appExportBase64: AppExportBase64,
    private activatedRoute: ActivatedRoute,
    private swalAlert: SwalAlertService
  ) {}

  ngOnInit() {
    this.activateRoute();
  }

  exportarTicket() {
    this.isLoading = true;

    this.agendamentoService.GetReceiptAgendamentoById(this.idTicket).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
        this.isLoading = false;

        this.swalAlert.showAlert(
          'Sucesso!',
          'Download do ticket efetuado com sucesso.',
          'success',
          false,
          false,
          undefined
        );
      },
      error: (error) => {
        this.isLoading = false;

        this.swalAlert.handleError(
          error,
          'Atenção!',
          'Ocorreu um erro no download do ticket.',
          'warning'
        );
      }
    });
  }

  activateRoute() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.idTicket = +params['PK_AGND'];
    });
  }
}
